import React, { useState, useEffect, useRef } from 'react';
import TypewriterEffect from "./TypewriterEffect"; // Import the TypewriterEffect component
import useOnScreen from "./hooks/useOnScreen"; // Import the useOnScreen hook

const FullWidthCTACard = ({ heading, subheading, button1Text, button2Text, onButton1Click, onButton2Click, animateHeading = false }) => {
  const ref = useRef();
  const onScreen = useOnScreen(ref, '-100px'); // Adjust rootMargin as needed

  return (
    <div ref={ref} className={`section-container cta-card-animation ${onScreen ? 'is-visible' : ''}`} style={{
      backgroundColor: '#1a1a1a',
      borderRadius: '24px',
      padding: '40px 48px',
      textAlign: 'center',
      color: '#ffffff',
      marginBottom: '60px',
      boxShadow: '0 12px 40px rgba(0,0,0,0.3)',
      transition: 'background-color 0.3s ease, transform 0.3s ease', // Added transition for hover effects
    }}
    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#2a2a2a'; e.currentTarget.style.transform = 'translateY(-5px)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#1a1a1a'; e.currentTarget.style.transform = 'translateY(0)'; }}>
      <h2 style={{
        fontSize: '32px',
        fontWeight: '700',
        marginBottom: '16px',
        lineHeight: '1.2'
      }}>
        {animateHeading && onScreen ? <TypewriterEffect text={heading} typingSpeed={50} /> : heading}
      </h2>
      <p style={{
        fontSize: '18px',
        color: '#cccccc',
        marginBottom: '40px',
        lineHeight: '1.5'
      }}>{subheading}</p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
        <button style={{
          backgroundColor: '#1a1a1a',
          color: '#f6f1e7',
          padding: '14px 28px',
          borderRadius: '30px',
          border: '1px solid #f6f1e7',
          fontSize: '16px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'background-color 0.3s ease, transform 0.2s ease, border-color 0.3s ease',
        }}
        onMouseEnter={(e) => { e.target.style.backgroundColor = '#f6f1e7'; e.target.style.color = '#1a1a1a'; e.target.style.transform = 'translateY(-2px)'; e.target.style.borderColor = '#1a1a1a'; }}
        onMouseLeave={(e) => { e.target.style.backgroundColor = '#1a1a1a'; e.target.style.color = '#f6f1e7'; e.target.style.transform = 'translateY(0)'; e.target.style.borderColor = '#f6f1e7'; }}
        onClick={onButton1Click}
        >
          {button1Text}
        </button>
        <button style={{
          backgroundColor: 'transparent',
          color: '#f6f1e7',
          padding: '14px 28px',
          borderRadius: '30px',
          border: '2px solid #f6f1e7',
          fontSize: '16px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'background-color 0.3s ease, color 0.3s ease, transform 0.2s ease',
        }}
        onMouseEnter={(e) => { e.target.style.backgroundColor = '#f6f1e7'; e.target.style.color = '#1a1a1a'; e.target.style.transform = 'translateY(-2px)'; e.target.style.borderColor = '#1a1a1a'; }}
        onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#f6f1e7'; e.target.style.transform = 'translateY(0)'; e.target.style.borderColor = '#f6f1e7'; }}
        onClick={onButton2Click}
        >
          {button2Text}
        </button>
      </div>
    </div>
  );
};

export default FullWidthCTACard;
